module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive--dark-81d491b947ea429ae9d7f1a19505ee65.png";